import routes from "router"
import { useNavigate, useRoutes } from "react-router-dom"
import { useGA } from "libs/ga"
import { useEffect } from "react"
import { useAppSelector } from "app/hooks"
import { setAxiosToken } from "api/requester"
import SnackbarHub from "components/SnackbarHub"
import { useInitBraze } from "libs/braze"
import { setZOZOFitAxiosToken } from "api/zozoFitRequester"
import usePreventScrollOutSideHtml from "hooks/usePreventScrollOutSideHtml"
import CustomSnackbar from "components/CustomSnackbar"
import * as Sentry from "@sentry/react"
import {
  getWebViewDetectionSignals,
  isInWebView,
} from "utils/webViewDetection"
import StandaloneShutdownPage from "components/StandaloneShutdownPage"
import { useRefreshFJUserPlan } from "features/payment/hooks"
import { useFoodJournalDataRefresh } from "hooks/useFoodJournalDataRefresh"


function App() {
  const token = useAppSelector((state) => state.auth.token)

  if (token) {
    setAxiosToken(token)
    setZOZOFitAxiosToken(token)
  }

  useRefreshFJUserPlan()
  useFoodJournalDataRefresh()

  const navigate = useNavigate()

  useEffect(() => {
    ;(window as any).navigateInFJ = (path: string) => {
      if (path.startsWith("/")) {
        navigate(path)
      }
    }
  }, [navigate])

  const elements = useRoutes(routes)
  const { initGA } = useGA()

  useEffect(() => {
    initGA()
  }, [])

  useInitBraze()
  usePreventScrollOutSideHtml()

  if (!isInWebView()) {
    Sentry.withScope((scope) => {
      scope.setFingerprint(["App", "standalone-shutdown"])
      scope.setContext("webview_detection", getWebViewDetectionSignals())
      Sentry.captureMessage(
        "[App/gate] isInWebView() false — rendering StandaloneShutdownPage",
        "warning",
      )
    })

    return <StandaloneShutdownPage />
  }

  return (
    <div className="app">
      <CustomSnackbar />
      <SnackbarHub />
      {elements}
    </div>
  )
}

export default App
